import React from "react";

const NB = () => {
  return (
    <div className="mt-3 nb">
      <hr />

      <p>SUNU BICIS exprime sa gratitude pour votre confiance.</p>
      <p>
        Le simulateur est à titre indicatif (sans frais de dossier et hors
        taxes), le client devra se déplacer en agence pour des informations
        complémentaires.
      </p>
    </div>
  );
};

export default NB;
